import React from 'react';
import Router from './PHPComponents/Router';

const App = () => {

  // Function to detect if DevTools are open
  const detectDevToolsOpen = () => {
    const threshold = 160; // Height or width threshold for detecting DevTools
    return (
      window.outerHeight - window.innerHeight > threshold ||
      window.outerWidth - window.innerWidth > threshold
    );
  };

  // Function to handle resize event
  const handleResize = () => {
    if (detectDevToolsOpen()) {
      window.location.href = 'https://www.google.com'; // Redirect to Google if DevTools are open
    }
  };

  // Set up event listeners when the component mounts
  window.addEventListener('resize', handleResize);

  // Initial check on component render
  if (detectDevToolsOpen()) {
    window.location.href = 'https://www.google.com'; // Redirect if DevTools are open
  }

  // Cleanup function to remove the event listener
  const cleanup = () => {
    window.removeEventListener('resize', handleResize);
  };

  React.useEffect(cleanup, []);

  document.addEventListener("keydown", (e) => {
    if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I") || (e.ctrlKey && e.shiftKey && e.key === "C")) {
      e.preventDefault();
    }
  });
  document.addEventListener("contextmenu", (e) => e.preventDefault());


  return (
    <>
      <Router />
    </>
  );
}

export default App;